import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {XCircle} from 'lucide-react';

const PaymentCancelPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [lang, setLang] = useState('zh');

  useEffect(() => {
    // 檢測語言
    const path = location.pathname;
    if (path.startsWith('/en')) {
      setLang('en');
    }
  }, [location.pathname]);

  const content = {
    zh: {
      title: '付款已取消',
      subtitle: '您的付款流程已中止',
      message: '如有任何問題，請聯繫我們的客服團隊。',
      retryButton: '重新付款',
      backButton: '返回首頁'
    },
    en: {
      title: 'Payment Cancelled',
      subtitle: 'Your payment process has been cancelled',
      message: 'If you have any questions, please contact our customer service team.',
      retryButton: 'Retry Payment',
      backButton: 'Back to Home'
    }
  };

  const t = content[lang as keyof typeof content];

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center px-4 py-12">
      <div className="max-w-md w-full bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 text-center">
        {/* 取消圖示 */}
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center">
            <XCircle className="w-10 h-10 text-red-600 dark:text-red-400" />
          </div>
        </div>

        {/* 標題 */}
        <h1 className="text-3xl font-light text-gray-900 dark:text-white mb-2">
          {t.title}
        </h1>
        <p className="text-lg text-gray-600 dark:text-gray-400 mb-6">
          {t.subtitle}
        </p>

        {/* 訊息 */}
        <p className="text-gray-600 dark:text-gray-400 mb-8">
          {t.message}
        </p>

        {/* 按鈕 */}
        <div className="space-y-3">
          <button
            onClick={() => navigate(`/${lang}/checkout`)}
            className="w-full bg-black dark:bg-white text-white dark:text-black py-3 rounded-lg hover:bg-gray-800 dark:hover:bg-gray-100 transition-colors"
          >
            {t.retryButton}
          </button>
          <button
            onClick={() => navigate(`/${lang}`)}
            className="w-full border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 py-3 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
          >
            {t.backButton}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelPage;
